import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import type { StyleDefinition } from "@circle-react-shared/BuilderUI/utils/styleMap";

import { processDirectValue } from "./processDirectValue";
import { processUnitValue } from "./processUnitValue";

export const processStyleValue = (
  styleValue: StyleValue,
  definition: StyleDefinition,
): string | number | undefined => {
  switch (definition.processorType) {
    case "unit":
      return processUnitValue(styleValue, definition.defaultUnit);
    case "direct":
      return processDirectValue(styleValue);
    case "custom":
      return definition.processor(styleValue);
    case "skipped":
      return undefined;
    default:
      console.warn("Unknown processor type.");
      return undefined;
  }
};
